module.exports = __webpack_public_path__ + "media/src/admin/images/min-adcdc23489f6d03ca8b644a855698e6a.svg";